import React, { forwardRef } from 'react';
import { FormLabel, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ReactComponent as Checked } from 'images/checked.svg';
import { ReactComponent as UnChecked } from 'images/unchecked.svg';

import { PageLoader } from 'shared-components/Loaders';
import { StyledPKDCheckbox } from './style';

export const PKDCheckbox = forwardRef(
  ({ label, onChange, checked, name, disabled, isLoading }, ref) => (
    <FormLabel
      sx={{ display: 'flex', marginBottom: '20px', cursor: 'pointer' }}>
      <Box
        marginRight='16px'>
        <StyledPKDCheckbox
          checkedIcon={<Checked />}
          icon={<UnChecked />}
          onChange={onChange}
          checked={checked}
          name={name}
          ref={ref}
          disabled={disabled}
          data-testid='pkd-checkbox-input'
        />
      </Box>
      <Typography
        cursor='pointer' {...(checked && { color: 'primary.black' })}>
        {label}
      </Typography>
      {isLoading && (
        <Box
          ml={2}>
          <PageLoader
            data-testid='page-loader' size={20}
          />
        </Box>
      )}
    </FormLabel>
  )
);
